export default __webpack_public_path__ + "static/media/popup_d.c04d0cf6.jpg";